const endpoints = {
  graphMe: {
    scope: 'User.Read',
    url: 'https://graph.microsoft.com/v1.0/me?$select=businessPhones,displayName,givenName,jobTitle,mail,mobilePhone,officeLocation,preferredLanguage,surname,department,userPrincipalName,id',
  },
  graphUsers: {
    scope: 'User.Read.All',
    url: 'https://graph.microsoft.com/v1.0/users?$select=businessPhones,displayName,givenName,jobTitle,mail,mobilePhone,officeLocation,preferredLanguage,surname,department,userPrincipalName,id&$filter=accountEnabled eq true',
  },
  graphProfilePhoto: {
    scope: 'User.Read.All',
    url: 'https://graph.microsoft.com/v1.0/users', //USERPRINCIPALNAME/photo/$value
  },
  getPriorityList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/PriorityList`,
  },
  getCategory: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/Category`,
  },
  getCategoryList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/CategoryList`,
  },
  getPriority: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/Priority`,
  },
  getSite: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/Site`,
  },
  getSiteList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/SiteList`,
  },
  getStatus: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/Status`,
  },
  getStatusList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/StatusList`,
  },
  getUser: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/User`,
  },
  getUserByLoginName: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/UserByLoginName`,
  },
  getUserGroups: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/UserGroups`,
  },
  getUserGroupsList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/UserGroupsList`,
  },
  getUserList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/UserList`,
  },
  getDesignatedSites: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/PickListValues/udf_pick_303`,
  },
  getSdPlusDepartments: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/PickListValues/udf_pick_311`,
  },
  submitSystemAccessTicket: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/Tickets/SystemAccessTicket`,
  },
  submitDeviceRequestTicket: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/Tickets/DeviceRequestTicket`,
  },
  submitIncidentRequestTicket: {
      scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
      url: `${process.env.REACT_APP_API}/Tickets/IncidentRequestTicket`,
  },
  getProgramList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/VirtuoHR/ProgramList`,
  },
  getDepartmentList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/VirtuoHR/DepartmentList`,
  },
  getFunctionalCentreList: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/VirtuoHR/FunctionalCentreList`,
  },
  getFunctionalCentreNames: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/VirtuoHR/FunctionalCentreNames`,
  },
  getDepartmentNames: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/VirtuoHR/DepartmentNames`,
  },
  getProgramNames: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/VirtuoHR/ProgramNames`,
  },
  getMyTickets: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/Tickets/MyTickets`,
  },
  getTicket: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/Tickets/Ticket`,
  },
  getDeviceTypes: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
    url: `${process.env.REACT_APP_API}/SDPlus/DeviceTypes`,
  },
  uploadFiles: {
    scope: 'api://ea1fe071-efc4-4c94-bfc1-38c32dfd6d51/access_as_user',
     url: `${process.env.REACT_APP_API}/SDPlus/UploadFiles/`,
  }
};

export default endpoints;
